var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsRead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21.996,
    viewBox: "0 0 20 21.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46006",
    "data-name": "Group 46006",
    transform: "translate(-1600 -57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-bell",
    "data-name": "Icon feather-bell",
    transform: "translate(1594 55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M18,8A6,6,0,1,0,6,8c0,7-3,9-3,9H21s-3-2-3-9",
    fill: "none",
    stroke: "#007bc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M13.73,21a2,2,0,0,1-3.46,0",
    fill: "none",
    stroke: "#007bc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsRead);
export default __webpack_public_path__ + "static/media/notifications-read.dad3cfdd70bd41fc2da926f5665f5f7f.svg";
export { ForwardRef as ReactComponent };